// import NgrxAuth from '../../auth/Auth'
// import { CALL_API } from '../../util/RBRestMiddleware'

export const UPDATE_URL = 'UPDATE_URL'
export const SET_PERCENT = 'SET_PERCENT'
export const SET_NEXT = 'SET_NEXT'
export const RESET_NEXT = 'RESET_NEXT'
export const GO_NEXT = 'GO_NEXT'
export const GO_BACK = 'GO_BACK'
export const CANCEL_CLAIM = 'CANCEL_CLAIM'
export const HAS_COB = 'HAS_COB'
export const OTHER_CARRIER_PAYMENT = 'OTHER_CARRIER_PAYMENT'
export const SUBMIT_AGAIN = 'SUBMIT_AGAIN'

export const PASS_NAV_MESSAGE = 'PASS_NAV_MESSAGE'
export const PASS_NAV_RESPONSE = 'PASS_NAV_RESPONSE'
export const CLEAR_NAV = 'CLEAR_NAV'

// HELP BUTTON
export const updateUrl = (url) => {
  return {
    type: UPDATE_URL,
    url
  }
}

// PROGRESS
export const setPercent = (percent) => {
  return {
    type: SET_PERCENT,
    percent
  }
}
// NAVIGATION
export const setNext = (next) => {
  return {
    type: SET_NEXT,
    next
  }
}

export const goNext = () => {
  return {
    type: GO_NEXT
  }
}

export const goBack = () => {
  return {
    type: GO_BACK
  }
}

export const Cancel = () => {
  return {
    type: CANCEL_CLAIM
  }
}

export const submitAgain = () => {
  return {
    type: SUBMIT_AGAIN
  }
}

// NAVIGATION POPUP
// first pass the message to the popup, giving the user to either reply yes or no
export const passMessage = (message) => {
  return {
    type: PASS_NAV_MESSAGE,
    message
  }
}
// user the response to run the next function
export const passResponse = (response) => {
  return {
    type: PASS_NAV_RESPONSE,
    response
  }
}
export const clearNavDialog = () => {
  return {
    type: CLEAR_NAV
  }
}

// SEND A FUNCTION TO THE NEXT BUTTON
export const PASS_NAV_CALLBACKS = 'PASS_NAV_CALLBACKS'

export const passNavCallbacks = (callBacks = {}) => {
  return {
    type: PASS_NAV_CALLBACKS,
    callBacks
  }
}

// export const CLEAR_NAV_FUNCTION = 'CLEAR_NAV_FUNCTION'
// export const clearNavFunction = () => {
//   return {
//     type:  CLEAR_NAV_FUNCTION
//   }
// }



// WEBPACK FOOTER //
// ./src/redux/actions/submitNavigationActions.js